export default "<p>\n    <b>404</b> - not found\n  <a routerLink=\"/\">на главную</a>\n</p>\n"